export default "__VITE_ASSET__Lwtb8yCC__"